import React, { useState, useRef, useLayoutEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { motion, useViewportScroll, useTransform, useMotionTemplate } from "framer-motion"
import tw from 'twin.macro'
import styled from '@emotion/styled'

import ValueProp from '../global/ValueProp'
import Container from '../global/Container'
import NewsletterForm from '../global/NewsletterForm'

import DisplayContext from '../../contexts/DisplayContext'

const HeroComponent = ({ data, newsletter, className }) => {
  const [elementTop, setElementTop] = useState(0);
  const ref = useRef(null);
  const { scrollY } = useViewportScroll()

  const newsletterData = newsletter ? newsletter : {
    heading: 'Placeholder heading',
    text: 'Placeholder text. To edit this content, use the Globals page.',
    action: '#'
  }

  const display = useContext(DisplayContext);

  const y = useTransform(scrollY, [elementTop, elementTop + 1], [0, -0.2], {
    clamp: false
  });

  const _heroScale = useTransform(scrollY, [elementTop, elementTop + 1], [0, 0.0001], {
    clamp: false
  });
  const heroScale = useMotionTemplate`scale(calc(1 + ${_heroScale}))`

  const _blurBg = useTransform(scrollY, [elementTop, elementTop + 1], [0, 0.01], {
    clamp: false
  });
  const blurBg = useMotionTemplate`blur(${_blurBg}px)`

  const titleText = {
    hidden: {
      opacity: 0,
    },
    show: { 
      opacity: 1,
      y: 0,
      transition: { delay: 0.5 },
    },
  }


  useLayoutEffect(() => {
    const element = ref.current;
    setElementTop(element.offsetTop);
  }, [ref]);

  return (
    <div className={className} ref={ref}>
        <div className="hero-text">
          <Container>
          <motion.h1
            style={{ y }}
            animate="show"
            variants={titleText}
            initial={display == 'live' ? 'hidden' : 'show'}
          >
            {data.heroTitle}
          </motion.h1>
          </Container>
        </div>
        <ValueProp className="value-prop" content={data.value} />
        <div className="mailing-list">
          <Container>
            <NewsletterForm className="mailing-list-form" data={newsletterData} />
          </Container>
        </div>
        <motion.div className="foreground" 
          style={{ 
            transform: heroScale, 
            backgroundImage: `url(${
              data.heroFg.childImageSharp
                ? data.heroFg.childImageSharp.fluid.src
                : data.heroFg
            })`,
          }}></motion.div>
        <motion.div
            style={{ 
              filter: blurBg, 
              transform: heroScale, 
              backgroundImage: `url(${
                data.heroBg.childImageSharp
                  ? data.heroBg.childImageSharp.fluid.src
                  : data.heroBg
              })`,
            }}
            className="background"
        />
    </div>
  )
}

HeroComponent.propTypes = {
  data: PropTypes.object.isRequired,
  newsletter: PropTypes.object,
  className: PropTypes.string.isRequired
}

const Hero = styled(HeroComponent)`
  ${tw`overflow-hidden bg-cover relative w-full`}
  height: 95vh;
  min-height: 800px;
  @media (max-width: 1250px) {
    min-height: 1000px;
  }
  @media (max-width: 1023px) {
    min-height: 900px;
  }
  @media (max-width: 639px) {
    min-height: 1000px;
  }
  .hero-text {
    ${tw`w-full absolute text-white`}
    z-index: 2;
    top: 14%;
    left: 0;
    h1 {
      font-size: 140px;
      line-height: 90%;
      @media (max-width: 1023px) {
        font-size: 100px;
      }
      @media (max-width: 767px) {
        font-size: 70px;
      }
    }
    
  }
  .foreground, .background {
    ${tw`overflow-hidden bg-cover absolute w-full`}
    height: 100%;
    background-position: center;
    top: 0;
  }
  .foreground { 
    z-index: 3; 
    transform-origin: 50% 80%;
  }
  .background { z-index: 1; }
  .mailing-list {
    position: absolute;
    bottom: 150px;
    z-index: 5;
    left: 0;
    width: 100%;
    @media (max-width: 639px) {
      bottom: 30px;
    }
  }
  .mailing-list-form {
    float: right;
    @media (max-width: 639px) {
      float: none;
      width: 100%
    }
  }
`

export default Hero
